import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageHeader from "../../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import TerritoryAddAndEditModal from "./components/TerritoryAddEditModal";
import OnboardWindowModal from "./components/OnboardWindowModal";
import RoundedDropdown from "../../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import { useGetTerritoryList } from "./UseTerriitory";
import { useGetOrgUnitsData } from "../../Employee/hooks/useEmployee";
import { FaEdit } from "react-icons/fa";
import { FaEye } from "react-icons/fa";


const TerritoriesColumns = (
  handleEditTerritory: (row: any) => void,
  handleView: (row: any) => void
) => [
    // {
    //   name: "Organisation Unit",
    //   selector: (row: { Organisation_unit: string }) =>
    //     row.Organisation_unit || "-",
    //   sortable: true,
    // },
    {
      name: "Name",
      selector: (row: { Name: string }) => row.Name || "-",
      sortable: true,
       minWidth: '150px',
        wrap:true
    },
    // {
    //   name: "Code",
    //   selector: (row: { Name: string|any }) => /* row?.TerritoryCode  ||*/ "-",
    //   sortable: true,
    //    width: '150px',
    //     wrap:true
    // },
    {
      name: "Position",
      selector: (row: { PositionName: string }) => row.PositionName || "-",
      sortable: true,
       minWidth: '150px',
        wrap:true
    },
    {
      name: "Onboarding Status",
      selector: (row: { Onboarding_status: string }) =>
        row.Onboarding_status || "-",
      sortable: true,
       minWidth: '250px',
        wrap:true
    },
    {
      name: "Start Date",
      selector: (row: { Start_date: string }) => row.Start_date || "-",
      sortable: true,
       minWidth: '180px',
        wrap:true
    },
    {
      name: "End Date",
      selector: (row: { End_date: string }) => row.End_date || "-",
      sortable: true,
       minWidth: '180px',
        wrap:true
    },
    {
      name: "Actions",
      cell: (row: any) => (
        <div className="d-flex align-items-center" style={{}}>
          <div className="d-flex align-items-center">
            <button
              onClick={() => handleEditTerritory(row)}
              className="btn btn-primary"
              style={{ borderRadius: "20px", padding: "2px", width: "70px" }}
            >
              <FaEdit style={{ fill: "#fff" }} /> Edit
            </button>
          </div>
          <div className="d-flex align-items-center" style={{ marginLeft: 10 }}>
            <button
              onClick={() => handleView(row)}
              className="btn btn-primary"
              style={{
                borderRadius: "20px",
                padding: "2px",
                width: "70px",
                backgroundColor: "#2e8dd3",
              }}
            >
              <FaEye style={{ fill: "#fff" }} />
              View
            </button>
          </div>
        </div>
      ),
      minWidth: "200px",
    },
  ];



const Territories = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { orgunitRowData } = location?.state || {};
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenOnboardWindow, setIsModalOpenOnboardWindow] = useState(false);
  const [checkAddEditStatus, setCheckAddEditStatus] = useState<any>("");
  const [rowData, setRwoData] = useState({});
  const [territoryDataTable, setTerritoryDataTable] = useState([]);
  const [filterData, setFilterData] = useState({
    search: "",
    OrgUnit: null,
    page: 1,
    limit: 10,
  });

  const { data, isLoading:isLoading} = useGetTerritoryList({
    enable:!!orgunitRowData?.OrgunitId,
    params: {
      OrgUnit: orgunitRowData?.OrgunitId,
      search: filterData.search,
      page: filterData.page,
      limit: filterData.limit,
    },
  });
// console.log('territoryDataTable',data.data.data);
//  console.log('orgunitRowData',orgunitRowData?.OrgunitId);

  useEffect(() => {
    if ( Array.isArray(data?.data?.data)) {
      const formatted = data.data.data.map((item: any) => ({
        id: item?.TerritoryId ?? "-",
        Organisation_unit: item?.UnitName ?? "-",
        Name: item?.TerritoryName ?? "-",
        Onboarding_status: item?.OnBoardingStatus?.value ?? "-",
        Start_date: item?.StartDate ?? "-",
        End_date: item?.EndDate ?? "-",
        Orgunitid: item?.Orgunitid ?? "-",
        PositionId: item?.PositionId ?? "-",
        PositionName: item?.PositionName ?? "-",
      }));
      setTerritoryDataTable(formatted);
    }
  }, [ data]);




  // const TerritoryDataTabel =
  //   !isLoading && isSuccess && Array.isArray(data?.data?.data)
  //     ? data.data.data.map((item: any) => ({
  //         id: item?.TerritoryId ?? "-",
  //         Organisation_unit: item?.UnitName ?? "-",
  //         Name: item?.TerritoryName ?? "-",
  //         Onboarding_status: item?.OnBoardingStatus?.value ?? "-",
  //         Start_date: item?.StartDate ?? "-",
  //         End_date: item?.EndDate ?? "-",
  //         Orgunitid : item?.Orgunitid ?? "-",
  //         PositionId :item?.PositionId ?? "-"
  //       }))
  //     : [];



  const { data: orgUnitsData, isLoading: orgDataLoading, isSuccess: orgDataSuccess, } = useGetOrgUnitsData({ enable: true });

  const handleEditTerritory = (row: any) => {
    setRwoData(row);
    setCheckAddEditStatus("Edit");
    setIsModalOpen(true);
  };

  const handleView = (row: any) => {
    const TerritoryId = row.id
    console.log('rowwwwwww',row)

    navigate("/towns", { state:row });
  };

  const toggleModal = () => {
    setCheckAddEditStatus("Add");
    setIsModalOpen(true);
  };

  const handlePagination = (pageNo: number) => {
    setFilterData((prev: any) => ({
      ...prev,
      page: pageNo,
    }));
  };
  const handleonChangeRowsPerPage = (limit: any, page: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      page: page,
      limit: limit,
    }));
  };
    const handleSearch = (searchValue: any) => {
    setFilterData((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  return (
    <div className="p-4">
      <PageHeader
        title="FSM"
        buttons={[
          {
            label: "+ Add Territory",
            onClick: toggleModal,
            color: "#2e8dd3",
          },
          // {
          //   label: "+ Create Onboard window",
          //   onClick: () => {
          //     setIsModalOpenOnboardWindow(true);
          //   },
          //   color: "#2e8dd3",
          // },
        ]}
      />
      <BasicDataTable
        Title="Territories List"
        columns={TerritoriesColumns(handleEditTerritory, handleView)}
        // data={(!isLoading && isSuccess && TerritoryDataTabel) || []}
        data={territoryDataTable || []}
        showSpinner={isLoading}
        headerContent={
          // <div
          //   style={{
          //     marginBottom: "15px",
          //     display: "flex",
          //     justifyContent: "flex-end",
          //   }}
          // >
          //   <RoundedDropdown
          //     options={!orgDataLoading && orgDataSuccess && orgUnitsData?.data || []}
          //     onSelect={(e: any) => setFilterData((prev: any) => ({
          //       ...prev,
          //       OrgUnit: e.label === "All" ? null : e.id
          //     }))}
          //     defaultLabel="All"
          //     width="auto"
          //     isShowHeading
          //     DropdownHeading="Org Unit"
          //     headingColor="#2e8dd3"
          //   />
          // </div>
          <></>
        }
        
          onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        paginationTotalRows={
          data?.data?.pagination?.total_records||0
        }
      />

      {isModalOpen && (
        <TerritoryAddAndEditModal
          rowData={rowData}
          setCheckAddEditStatus={setCheckAddEditStatus}
          checkAddEditStatus={checkAddEditStatus}
          setIsModalOpen={setIsModalOpen}
          isModalOpen={isModalOpen}
          title={checkAddEditStatus == "Add" ? "Add Territory" : "Edit Territory"}
        />

      )}
      <OnboardWindowModal
        handleSubmit={() => {
          alert("Hello");
        }}
        setIsModalOpen={setIsModalOpenOnboardWindow}
        isModalOpen={isModalOpenOnboardWindow}
        title={"Add onboard window"}
      />
    </div>
  );
};

export default Territories;
